import { LEARNER_ATTENDANCE_TRAINING_SLUG } from '@/queries/constants'
import PlatformFeedbackQ from '@/queries/PlatformFeedbackQ'
import PolicyViolationQ from '@/queries/PolicyViolationQ'
import TrainingQ from '@/queries/TrainingQ'
import { useQuery } from '@/client/context/query'
import type { SuspensionAction } from '@/client/services/user'

import { trainingFromQuery } from '@/components/Training/common'

import RestrictedPagePotentiallySuspendedApp from './RestrictedPagePotentiallySuspended.app'

export default function RestrictedPagePotentiallySuspended({
  suspensionAction,
}: {
  suspensionAction: SuspensionAction
}): JSX.Element {
  const query = useQuery()
  const learnerAttendanceTraining = trainingFromQuery({
    training: query.one(TrainingQ.where({ slug: LEARNER_ATTENDANCE_TRAINING_SLUG })),
    submission: null,
  })
  const { platformFeedbackId, policyViolationId } = suspensionAction
  const platformFeedback =
    platformFeedbackId != null
      ? query.one(PlatformFeedbackQ.where({ id: platformFeedbackId }))
      : null
  const policyViolation =
    policyViolationId != null ? query.one(PolicyViolationQ.where({ id: policyViolationId })) : null
  const policyViolationType =
    policyViolation?.(PolicyViolationQ.type) ??
    platformFeedback?.(PlatformFeedbackQ.policy_violation_type) ??
    null

  return (
    <RestrictedPagePotentiallySuspendedApp
      suspensionAction={suspensionAction}
      learnerAttendanceTraining={learnerAttendanceTraining}
      policyViolationType={policyViolationType}
    />
  )
}
